/* -------------------------------------------------------------------------- */
/*                                 Schema Providers                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sparePart = new schema.Entity('spareParts', {}, { idAttribute: 'sparePartId' });
export const spareParts = new schema.Array(sparePart);
